const styles = {
  card: {
    borderRadius: 3,
  },
  iconContainer: (item) => ({
    padding: 1.5,
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: item?.bg,
  }),
  icon: (item) => ({
    fontSize: 30,
    color: item?.color,
  }),
};

export default styles;
